import { createSevenroomsAudience } from '@store/venue/integrations/SevenroomsAudienceReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Create from './Create'

export const SevenroomsAudienceForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.sevenroomsAudience)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createSevenroomsAudience(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

SevenroomsAudienceForm.displayName = 'SevenroomsAudienceForm'

export default SevenroomsAudienceForm
